<h2 mat-dialog-title>Grant Access to Groups</h2>
<mat-dialog-content>
  <app-user-groups
  [existingGroupIds]="groupIds"
  [topLevelSelection]="true"
  (groupsChange)="onGroupsChange($event)"
  [topLevelDisablesChildren]="false"
  [showSelectedGroups]="true"
  [defaultTenantId]="data?.tenantId">
  </app-user-groups>      
</mat-dialog-content> 
<mat-dialog-actions align="end">
  <button mat-flat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary"  (click)="onGrantAccess()" cdkFocusInitial>Grant Access</button>
</mat-dialog-actions>